export default __webpack_public_path__ + "static/media/pic3.f6577377.jpg";